import UserService from './user/UserService';
import EventService from './event/EventService';
import { Event } from '../models/event';
import { EventDataSchema } from './Schemas/EventSchema';

interface DataServiceInterface {
  getUserData(uid: string): Promise<any>;
  setUserData(uid: string, displayName: string, photoURL: string, email: string): Promise<any>;
  deleteUserData(uid: string): Promise<void>;
  createEvent(uid: string, eventData: Event): Promise<void>;
  createEvent_DEPRECATE(uid: string, eventData: any, imageURL?: string): Promise<string>;
  getEvent_DEPRECATE(eventId: string): Promise<any>;
  getEvent(eventId: string): Promise<Event>;
  updateEvent(uid: string, eventId: string, eventData: Event): Promise<void>;
  updateEvent_DEPRECATE(uid: string, eventId: string, eventData: any, imageURL?: string): Promise<void>;
  getUserEvents(uid: string): Promise<{ id: any, data: EventDataSchema }[]>;
  getPublicEvents(): Promise<any[]>;
  deleteEvent(eventId: string): Promise<void>;
  createEventImageUpload(image: File, uid: string): Promise<string>;
  setAttendee(eventId: string, attendee: any): Promise<void>;
  setAttendees(eventId: string, attendees: any): Promise<void>;
  deleteAttendee(eventId: string, attendeeId: string): Promise<void>;
  getAttendee(eventId: string, attendeeId: string): Promise<any>;
  getAttendees(eventId: string): Promise<any[]>;
}

class CombinedService implements DataServiceInterface {
  private userService = new UserService();
  private eventService = new EventService();

  getUserData(uid: string): Promise<any> {
    return this.userService.getUserData(uid);
  }

  setUserData(uid: string, displayName: string, photoURL: string, email: string): Promise<any> {
    return this.userService.setUserData(uid, displayName, photoURL, email);
  }

  deleteUserData(uid: string): Promise<void> {
    return this.userService.deleteUserData(uid);
  }

  createEvent_DEPRECATE(eventData: any): Promise<string> {
    return this.eventService.createEvent_DEPRECATE(eventData);
  }

  createEvent(uid: any, eventData: Event): Promise<any> {
    return this.eventService.createEvent(uid, eventData);
  }

  getEvent_DEPRECATE(eventId: string): Promise<any> {
    return this.eventService.getEvent_DEPRECATE(eventId);
  }

  getEvent(eventId: string): Promise<Event> {
    return this.eventService.getEvent(eventId);
  }

  updateEvent_DEPRECATE(eventId: string, eventData: any): Promise<void> {
    return this.eventService.updateEvent_DEPRECATE(eventId, eventData);
  }

  updateEvent(uid: string, eventId: string, eventData: Event): Promise<void> {
    return this.eventService.updateEvent(uid, eventId, eventData);
  }

  getUserEvents(uid: string): Promise<{ id: string, data: EventDataSchema }[]> {
    return this.eventService.getUserEvents(uid);
  }

  getPublicEvents(): Promise<any[]> {
    return this.eventService.getPublicEvents();
  }

  deleteEvent(eventId: string): Promise<void> {
    return this.eventService.deleteEvent(eventId);
  }

  createEventImageUpload(image: File, uid: string): Promise<string> {
    return this.eventService.createEventImageUpload(image, uid);
  }

  setAttendee(eventId: string, attendee: any): Promise<void> {
    return this.eventService.setAttendee(eventId, attendee);
  }

  setAttendees(eventId: string, attendees: any): Promise<void> {
    return this.eventService.setAttendees(eventId, attendees);
  }

  deleteAttendee(eventId: string, attendeeId: string): Promise<void> {
    return this.eventService.deleteAttendee(eventId, attendeeId);
  }

  getAttendee(eventId: string, attendeeId: string): Promise<any> {
    return this.eventService.getAttendee(eventId, attendeeId);
  }

  getAttendees(eventId: string): Promise<any[]> {
    return this.eventService.getAttendees(eventId);
  }

}

class DataService {
  private static combinedService = new CombinedService();

  static getUserData(uid: string): Promise<any> {
    return this.combinedService.getUserData(uid);
  }

  static setUserData(uid: string, displayName: string, photoURL: string, email: string): Promise<any> {
    return this.combinedService.setUserData(uid, displayName, photoURL, email);
  }

  static deleteUserData(uid: string): Promise<void> {
    return this.combinedService.deleteUserData(uid);
  }

  static createEvent(userId: any, eventData: Event): Promise<any> {
    return this.combinedService.createEvent(userId, eventData);
  }

  static getEvent(eventId: string): Promise<Event> {
    return this.combinedService.getEvent(eventId);
  }

  static createEvent_DEPRECATE(eventData: any): Promise<string> {
    return this.combinedService.createEvent_DEPRECATE(eventData);
  }

  static getEvent_DEPRECATE(eventId: string): Promise<any> {
    return this.combinedService.getEvent_DEPRECATE(eventId);
  }

  static updateEvent_DEPRECATE(eventId: string, eventData: any): Promise<void> {
    return this.combinedService.updateEvent_DEPRECATE(eventId, eventData);
  }

  static updateEvent(userId: string, eventId: string, eventData: Event): Promise<void> {
    return this.combinedService.updateEvent(userId, eventId, eventData);
  }

  static getUserEvents(uid: string): Promise<{ id: string, data: EventDataSchema }[]> {
    return this.combinedService.getUserEvents(uid);
  }

  static getPublicEvents(): Promise<any[]> {
    return this.combinedService.getPublicEvents();
  }

  static deleteEvent(eventId: string): Promise<void> {
    return this.combinedService.deleteEvent(eventId);
  }

  static createEventImageUpload(image: File, uid: string): Promise<string> {
    return this.combinedService.createEventImageUpload(image, uid);
  }

  static setAttendee(eventId: string, attendee: any): Promise<void> {
    return this.combinedService.setAttendee(eventId, attendee);
  }

  static setAttendees(eventId: string, attendees: any): Promise<void> {
    return this.combinedService.setAttendees(eventId, attendees);
  }

  static deleteAttendee(eventId: string, attendeeId: string): Promise<void> {
    return this.combinedService.deleteAttendee(eventId, attendeeId);
  }

  static getAttendee(eventId: string, attendeeId: string): Promise<any> {
    return this.combinedService.getAttendee(eventId, attendeeId);
  }

  static getAttendees(eventId: string): Promise<any[]> {
    return this.combinedService.getAttendees(eventId);
  }

}

export default DataService;